import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getIdPersonaToken(idpersona) {
    try {
      const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}get-user-token`, { 
        params: { idpersona },
      });
      // El token se guarda en las cookies
      return response

    } catch (error) {
      console.error('Error al conseguir el token del usuario', error);
    }
  }